import { RootState } from 'configs/redux';

export const userOpenRegistrationsSelector = (state: RootState) =>
  state.userOpenRegistrations;
